import {
  FileSpreadsheet,
  Map,
  Users,
  FolderOpen,
  MessageCircle,
  Store,
  LucideIcon,
} from "lucide-react";

export interface SolutionItem {
  icon: LucideIcon;
  title: string;
  description: string;
}

export const solutions: SolutionItem[] = [
  {
    icon: FileSpreadsheet,
    title: "Deal Analyzer",
    description:
      "Skip the spreadsheet chaos. Model your hotel financials in minutes — revenue, costs, returns — all visualized beautifully.",
  },
  {
    icon: Map,
    title: "150+ Step Playbook",
    description:
      "The exact roadmap we used to launch hotels across 3 continents. Every phase, every milestone, zero guesswork.",
  },
  {
    icon: Users,
    title: "Expert on Demand",
    description:
      "20+ seasoned consultants across real estate, F&B, and operations. Book a call when you need guidance.",
  },
  {
    icon: FolderOpen,
    title: "Plug & Play Templates",
    description:
      "SOPs, checklists, handover docs — all the boring stuff that separates pros from amateurs. Just add your logo.",
  },
  {
    icon: MessageCircle,
    title: "Founders Circle",
    description:
      "Weekly office hours with operators who have been there. Real talk, real problems, real solutions.",
  },
  {
    icon: Store,
    title: "Vetted Partners",
    description:
      "Architects, designers, booking system vendors, and consultants — pre-vetted so you connect with the right people.",
  },
];
